// extracted by mini-css-extract-plugin
export default {"InfoBoxForm":"InfoBoxForm_InfoBoxForm__Zhh7O","FormError":"InfoBoxForm_FormError__S7a13"};